import { Card, Empty } from 'antd';

import FunnelBarWithPercentageComparison from '../../components/ManagerDashboard/FunnelBarWithPercentageComparison';
import { JobPostingCandidateStageCount, RecruitmentProcessCollection } from '../../types';

interface ConversionFunnelProps {
  totalVacancyPositions: number;
  totalCandidates?: number;
  dashboardStatus?: RecruitmentProcessCollection['status'];
  subscribedCount?: number;
  recruitmentProcessesCountByStage?: JobPostingCandidateStageCount[];
  statusRecruitmentProcessesCountByStage?: JobPostingCandidateStageCount[];
}

const ConversionFunnel = ({
  totalVacancyPositions,
  totalCandidates,
  dashboardStatus,
  subscribedCount,
  recruitmentProcessesCountByStage,
  statusRecruitmentProcessesCountByStage,
}: ConversionFunnelProps) => {
  return (
    <Card>
      {totalCandidates === subscribedCount ? (
        <Empty description="Não há dados suficientes ainda para avaliar conversão" />
      ) : (
        <>
          {recruitmentProcessesCountByStage?.map((stage, idx) => {
            return (
              <FunnelBarWithPercentageComparison
                key={stage.id}
                totalVacancyPositions={totalVacancyPositions}
                stageName={stage.name}
                totalCandidates={totalCandidates || 1}
                previousStageCounter={
                  recruitmentProcessesCountByStage?.[idx - 1]?.candidate_count ?? 0
                }
                accumulatedCounter={
                  recruitmentProcessesCountByStage
                    ?.slice(idx)
                    .reduce((acc, curr) => acc + curr.candidate_count, 0) ?? 0
                }
                currentStageCounter={
                  statusRecruitmentProcessesCountByStage?.[idx].candidate_count ?? 0
                }
                dashboardStatus={dashboardStatus}
              />
            );
          })}
        </>
      )}
    </Card>
  );
};

export default ConversionFunnel;
